import countrySettings from '../countrySettings.json';
import GeneralDataCL from './GeneralDataCL';
import GeneralDataPE from './GeneralDataPE';

const COMPONENTS = { CL: GeneralDataCL, PE: GeneralDataPE };

const GeneralData = (props) => {
  const variant = countrySettings.componentVariant.generalData[props.countryCode] ?? 'CL';
  const Component = COMPONENTS[variant];
  return <Component {...props} />;
};

export default GeneralData;
